let sessionId: string = '';
let interactionId: string | null = null;

export function initializeCorrelation(): void {
  sessionId = crypto.randomUUID();
}

export function startInteraction(): string {
  interactionId = crypto.randomUUID();
  return getCurrentId();
}

export function endInteraction(): void {
  interactionId = null;
}

export function getCurrentId(): string {
  if (!sessionId) {
    initializeCorrelation();
  }
  return interactionId ? `${sessionId}:${interactionId}` : sessionId;
}

export function getSessionId(): string {
  if (!sessionId) {
    initializeCorrelation();
  }
  return sessionId;
}
